import feature from 'vue-feature-toggle'

const enabled = () => true
// const isNotProduction = () => process.env.NODE_ENV !== 'production'

feature.visibility('configs', () => false)
feature.visibility('calendar-configuration', enabled)
feature.visibility('epg-content-config', enabled)
feature.visibility('asset-manager', enabled)
feature.visibility('team-mashup', enabled)
feature.visibility('banners', enabled)
feature.visibility('sponsorship-config', enabled)
feature.visibility('webview', enabled)
feature.visibility('branding', enabled)
feature.visibility('app-navigation', enabled)
feature.visibility('stats', enabled)
feature.visibility('cdmenu', enabled)
feature.visibility('messages', enabled)
feature.visibility('paywall', enabled)
feature.visibility('mobile-util-pages', enabled)
feature.visibility('string-override', enabled)
feature.visibility('gumbo-websocket-driver', enabled)

export default feature
